/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePackageDto,
  PackageListResponse,
  PackageResponse,
  PackagesListParams,
  UpdatePackageDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * قیمت‌ها به **ریال**. soldCount تعداد دفعاتی است که این پکیج به بیماران فروخته شده.
 * @summary فهرست پکیج‌های کلینیک
 */
export const packagesList = (
    params?: PackagesListParams,
 signal?: AbortSignal
) => {


      return apiClient<PackageListResponse>(
      {url: `/api/v1/packages`, method: 'GET',
        params, signal
    },
      );
    }




export const getPackagesListQueryKey = (params?: PackagesListParams,) => {
    return [
    `/api/v1/packages`, ...(params ? [params] : [])
    ] as const;
    }


export const getPackagesListQueryOptions = <TData = Awaited<ReturnType<typeof packagesList>>, TError = void>(params?: PackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof packagesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPackagesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof packagesList>>> = ({ signal }) => packagesList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof packagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PackagesListQueryResult = NonNullable<Awaited<ReturnType<typeof packagesList>>>
export type PackagesListQueryError = void


export function usePackagesList<TData = Awaited<ReturnType<typeof packagesList>>, TError = void>(
 params: undefined |  PackagesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof packagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof packagesList>>,
          TError,
          Awaited<ReturnType<typeof packagesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePackagesList<TData = Awaited<ReturnType<typeof packagesList>>, TError = void>(
 params?: PackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof packagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof packagesList>>,
          TError,
          Awaited<ReturnType<typeof packagesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePackagesList<TData = Awaited<ReturnType<typeof packagesList>>, TError = void>(
 params?: PackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof packagesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست پکیج‌های کلینیک
 */

export function usePackagesList<TData = Awaited<ReturnType<typeof packagesList>>, TError = void>(
 params?: PackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof packagesList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPackagesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * sessionCount اندازهٔ کل استخر جلسات است و هر procedures[].sessionCount سقف مصرف همان خدمت. اگر sessionCount را نفرستید، برابر مجموع سقف‌ها در نظر گرفته می‌شود.
 * @summary ساخت پکیج
 */
export const packagesCreate = (
    createPackageDto: CreatePackageDto,
 signal?: AbortSignal
) => {


      return apiClient<PackageResponse>(
      {url: `/api/v1/packages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPackageDto, signal
    },
      );
    }




export const getPackagesCreateMutationKey = () => ['packagesCreate'] as const;

export const getPackagesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof packagesCreate>>, TError,PackagesCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof packagesCreate>>, TError,PackagesCreateMutationVariables, TContext> => {

const mutationKey = getPackagesCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof packagesCreate>>, PackagesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  packagesCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PackagesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof packagesCreate>>>
    export type PackagesCreateMutationBody = CreatePackageDto
    export type PackagesCreateMutationError = void
    export type PackagesCreateMutationVariables = {data: CreatePackageDto}

    /**
 * @summary ساخت پکیج
 */
export const usePackagesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof packagesCreate>>, TError,PackagesCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof packagesCreate>>,
        TError,
        PackagesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getPackagesCreateMutationOptions(options), queryClient);
    }
    /**
 * @summary جزئیات یک پکیج
 */
export const packagesGetById = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<PackageResponse>(
      {url: `/api/v1/packages/${id}`, method: 'GET', signal
    },
      );
    }




export const getPackagesGetByIdQueryKey = (id: string,) => {
    return [
    `/api/v1/packages/${id}`
    ] as const;
    }


export const getPackagesGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof packagesGetById>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof packagesGetById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPackagesGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof packagesGetById>>> = ({ signal }) => packagesGetById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof packagesGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PackagesGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof packagesGetById>>>
export type PackagesGetByIdQueryError = void


export function usePackagesGetById<TData = Awaited<ReturnType<typeof packagesGetById>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof packagesGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof packagesGetById>>,
          TError,
          Awaited<ReturnType<typeof packagesGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePackagesGetById<TData = Awaited<ReturnType<typeof packagesGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof packagesGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof packagesGetById>>,
          TError,
          Awaited<ReturnType<typeof packagesGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePackagesGetById<TData = Awaited<ReturnType<typeof packagesGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof packagesGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک پکیج
 */

export function usePackagesGetById<TData = Awaited<ReturnType<typeof packagesGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof packagesGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPackagesGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * تغییر قیمت یا فهرست خدمات، روی پکیج‌هایی که قبلاً فروخته شده‌اند هیچ اثری ندارد: هر فروش نسخهٔ منجمدشدهٔ خودش را نگه می‌دارد.
 * @summary ویرایش پکیج
 */
export const packagesUpdate = (
    id: string,
    updatePackageDto: UpdatePackageDto,
 signal?: AbortSignal
) => {


      return apiClient<PackageResponse>(
      {url: `/api/v1/packages/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePackageDto, signal
    },
      );
    }




export const getPackagesUpdateMutationKey = () => ['packagesUpdate'] as const;

export const getPackagesUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof packagesUpdate>>, TError,PackagesUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof packagesUpdate>>, TError,PackagesUpdateMutationVariables, TContext> => {

const mutationKey = getPackagesUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof packagesUpdate>>, PackagesUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  packagesUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PackagesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof packagesUpdate>>>
    export type PackagesUpdateMutationBody = UpdatePackageDto
    export type PackagesUpdateMutationError = void
    export type PackagesUpdateMutationVariables = {id: string;data: UpdatePackageDto}

    /**
 * @summary ویرایش پکیج
 */
export const usePackagesUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof packagesUpdate>>, TError,PackagesUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof packagesUpdate>>,
        TError,
        PackagesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getPackagesUpdateMutationOptions(options), queryClient);
    }
    /**
 * حذف نرم. پکیج‌های فروخته‌شده دست‌نخورده باقی می‌مانند و جلساتشان تا آخر قابل استفاده است؛ فقط این تعریف از صفحهٔ فروش برداشته می‌شود.
 * @summary حذف پکیج
 */
export const packagesRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/packages/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getPackagesRemoveMutationKey = () => ['packagesRemove'] as const;

export const getPackagesRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof packagesRemove>>, TError,PackagesRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof packagesRemove>>, TError,PackagesRemoveMutationVariables, TContext> => {

const mutationKey = getPackagesRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof packagesRemove>>, PackagesRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  packagesRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PackagesRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof packagesRemove>>>

    export type PackagesRemoveMutationError = void
    export type PackagesRemoveMutationVariables = {id: string}

    /**
 * @summary حذف پکیج
 */
export const usePackagesRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof packagesRemove>>, TError,PackagesRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof packagesRemove>>,
        TError,
        PackagesRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getPackagesRemoveMutationOptions(options), queryClient);
    }
